/*eslint-disable*/
import { removeEmptyProperties } from "../../helpers/general"

export const makeCreateGroupDTO = (group) => {
  const { groupName: name, description } = group;
  return {
    name,
    description,
  };
};

export const areFormValuesChanged = (user={}) => {
  if(Object.keys(removeEmptyProperties(user))?.length>0) {
    return true;
  }
  return false;
}
